export default [
  {
    altText: "ขับรถหารายได้เสริมกับแอร์เอเชีย!",
    bannerID: "Driver-Rider-Recruitment_TH",
    buttonText: "",
    buttonUrl: "",
    desktopImage:
      "https://www.airasia.com/aa/driver-rider/images/Driver-Rider-Recruitment_dekstop_id.jpg",
    headline: "",
    mobileImage:
      "https://www.airasia.com/aa/driver-rider/images/Driver-Rider-Recruitment_mobile_id.jpg",
    subheadline: "",
    tabletImage:
      "https://www.airasia.com/aa/driver-rider/images/Driver-Rider-Recruitment_dekstop_id.jpg",
  }
]
